export const state = () => ({
    podcasts: [],
});
